import * as L from "leaflet";
import config from "../../../config";
import { IBoundLayer, IBoundLayerOptions } from "../../BoundLayer";
import { getWorldLayerState } from "../../../redux/rootReducer";
import { WORLD_LAYER_SATELLITE_MAP_TOGGLED } from "../../../redux/modules/worldLayer/reducer";
import { showEsriCredit } from "../../mapCredit";
import { OSM_ATTRIBUTION } from "../../osmAttribution";

const esriImageryUrl = (key: string) =>
  `https://ibasemaps-api.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}?token=${key}`;

// Street and place names: Esri serves them as a separate transparent layer.
const esriLabelsUrl = (key: string) =>
  `https://static-map-tiles-api.arcgis.com/arcgis/rest/services/static-basemap-tiles-service/v1/arcgis/imagery/labels/static/tile/{z}/{y}/{x}?token=${key}`;

export default class WorldLayer extends L.LayerGroup implements IBoundLayer {
  public options: IBoundLayerOptions;
  public map: L.Map;

  constructor(options: IBoundLayerOptions) {
    super();
    L.Util.setOptions(this, options);
    this.redraw();
  }

  public update(action: IAction<any>) {
    if (action.type === WORLD_LAYER_SATELLITE_MAP_TOGGLED) {
      this.redraw();
    }
  }

  private redraw() {
    this.clearLayers();
    const worldLayerState = getWorldLayerState(this.options.getState());
    if (worldLayerState.satelliteLayerIsOn) {
      const imageryUrl = esriImageryUrl(config.esriApiKey);
      const labelsUrl = esriLabelsUrl(config.esriApiKey);
      const imagery = L.tileLayer(imageryUrl, {
        ...config.osmLayerOptions,
        zIndex: this.options.zIndex,
      });
      const labels = L.tileLayer(labelsUrl, {
        ...config.osmLayerOptions,
        tileSize: 512,
        zoomOffset: -1,
        zIndex: this.options.zIndex,
      });
      showEsriCredit(
        { layer: imagery, url: imageryUrl },
        { layer: labels, url: labelsUrl },
      );
      this.addLayer(imagery);
      this.addLayer(labels);
    } else {
      this.addLayer(
        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
          ...config.osmLayerOptions,
          zIndex: this.options.zIndex,
          attribution: OSM_ATTRIBUTION,
        }),
      );
    }
  }
}
